import React, { FC, PropsWithChildren } from 'react';
import { Stack } from '@mui/material';

export const TabPanel: FC<
  PropsWithChildren<{
    value: number | string;
    selected: number | string;
    keepMounted?: boolean;
    className?: string;
  }>
> = ({ value, selected, children, keepMounted, className }) => {
  const shown = value === selected;
  if (!shown && !keepMounted) {
    return null;
  }
  if (keepMounted) {
    return (
      <Stack sx={{ display: shown ? 'flex' : 'none' }} className={className}>
        {children}
      </Stack>
    );
  }
  return <>{children}</>;
};
